import {
  BlockType,
  FCHeaderBlock,
  FCPrimaryBlock,
  HeaderBlockType,
  PrimaryBlockConfig,
  TertiaryBlockSize,
} from "@kameleon-core/types";
import React, {
  ComponentType,
  ForwardRefExoticComponent,
  ReactElement,
} from "react";
import {
  backgroundColorModeMapper,
  BackgroundColorWithMode,
} from "@kameleon-util/global-theme";
import { ThemeableBlock } from "./themeable-block";

/** PrimaryHeaderBlock layout */
function headerBlock<T extends HeaderBlockType>(
  config: PrimaryBlockConfig,
  RenderComponent: ComponentType<T> | ForwardRefExoticComponent<T>
): FCHeaderBlock<T> {
  const { secondaryBlockSize, blockTheme } = config;

  const block: FCPrimaryBlock<T> = (props: T): ReactElement => {
    const className = "header-primary--block";

    // Do not wrap the component in a themeable primary block theme whenever it is already part of another primaryCollectionBlock
    const propsAsAny = props as any;
    let themeMode = blockTheme;
    let backgroundColorWithMode: BackgroundColorWithMode | undefined;

    if (propsAsAny?.layoutProps?.backgroundColor) {
      backgroundColorWithMode = backgroundColorModeMapper(
        propsAsAny.layoutProps.backgroundColor
      );
      themeMode = backgroundColorWithMode.mode;
    }

    return (
      <ThemeableBlock
        isInnerBlock={false}
        blockType={BlockType.Header}
        blockTheme={themeMode}
        backgroundColorWithMode={backgroundColorWithMode}
        className={className}
      >
        <RenderComponent {...props} />
      </ThemeableBlock>
    );
  };
  block.blockConfig = config;
  block.secondaryBlockSize = secondaryBlockSize;
  block.tertiaryBlockSize = TertiaryBlockSize.None;
  block.blockType = BlockType.Header;
  block.blockTheme = blockTheme;
  return block;
}

export { headerBlock };
